var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMolionOfoghi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.6,8h-0.7c-0.2,0-0.3-0.1-0.6-0.4l-0.6-0.8L21,7.6c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2 c-0.2,0-0.4-0.1-0.4-0.3c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.2,0.3-0.3l0.7-0.9l-1-1.2l-0.2-0.2l-0.1-0.2c0-0.2,0.1-0.4,0.3-0.4 H21c0.2,0,0.3,0.2,0.6,0.5L22,5.4l0.6-0.8C22.8,4.4,23,4.3,23,4.3c0.1,0,0.3,0.1,0.3,0.2v0.1c0,0.2-0.3,0.6-1,1.2l1,1.4 c0.1,0.1,0.3,0.4,0.3,0.5S23.7,8,23.6,8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.2,26.5 22.3,23.3 20.3,20.4 22.2,20.4 23.3,22 24.4,20.4 26.3,20.4 24.2,23.3 26.5,26.5 24.5,26.5 23.3,24.6  22,26.5  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6,9.9h-7.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h7.8c0.3,0,0.5,0.2,0.5,0.5S18.9,9.9,18.6,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,9.9c-0.3,0-0.5-0.2-0.5-0.5V2.6c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v6.8C15.5,9.6,15.3,9.9,15,9.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.1,3 17.9,3 15,0  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6,20.7h-7.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h7.8c0.3,0,0.5,0.2,0.5,0.5S18.9,20.7,18.6,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,27.9c-0.3,0-0.5-0.2-0.5-0.5v-6.8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v6.8C15.5,27.7,15.3,27.9,15,27.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.9,27 12.1,27 15,30  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1,15.8H0.9c-0.5,0-0.9-0.5-0.9-1c0-0.6,0.4-1,0.9-1h28.1c0.5,0,0.9,0.5,0.9,1C30,15.3,29.6,15.8,29.1,15.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMolionOfoghi);
export default __webpack_public_path__ + "static/media/molion_ofoghi.0daa55e353739296294416aed21f0d3e.svg";
export { ForwardRef as ReactComponent };